import { ChannelName } from '../../../../learnware/LearnwareEnums';
import { MediaChannel } from '../MediaChannel';
export class ChannelVoice extends MediaChannel {
    channelName = ChannelName.Voice;
}
